import { useMultiuserContext, useSynchronizedState } from "@solidwhite/multiuser";
import ModalWithPortal from "../../../ui-components/Carousel/ModalWithPortal";
import { useEffect, useRef } from "react";

const VideoPlayerPortal = ({ ...props }) => {
  const { spectating, presenting } = useMultiuserContext();
  const videoRef = useRef();

  const [isOpenPortal, setIsOpenPortal] = useSynchronizedState(`VideoPlayer`, false);

  const [videoSrc, setVideoSrc] = useSynchronizedState("VideoPlayerSrc", "");
  const [currentVideoTime, setCurrentVideoTime] = useSynchronizedState("VideoPlayerTime", 0);
  const [playing, setPlaying] = useSynchronizedState("VideoPlayerPlaying", true);

  useEffect(() => {
    if (spectating && videoRef.current) {
      videoRef.current.currentTime = currentVideoTime;
    }
  }, [currentVideoTime]);

  useEffect(() => {
    if (spectating && videoRef.current) {
      if (playing) {
        videoRef.current.play();
      } else {
        videoRef.current.pause();
      }
    }
  }, [playing]);

  const handleSeek = (e) => {
    if (presenting) {
      setCurrentVideoTime(e.target.currentTime);
    }
  };

  const handlePause = (e) => {
    setPlaying(false);
  };

  const handlePlay = (e) => {
    setPlaying(true);
  };

  const isElectron = import.meta.env.MODE === "electron";

  return (
    <ModalWithPortal isOpenPortal={isOpenPortal} setIsOpenPortal={setIsOpenPortal}>
      <video
        ref={videoRef}
        src={videoSrc}
        autoPlay
        controls
        onSeeked={handleSeek}
        onPause={handlePause}
        onPlay={handlePlay}
        onChange={(e) => console.log(e)}
        style={{ pointerEvents: spectating ? "none" : "auto" }}
        onClick={(e) => {
          e.stopPropagation();
        }}
        {...(isElectron && {
          controlsList: "nodownload nofullscreen noplaybackrate",
          disablePictureInPicture: true,
        })}
      ></video>
    </ModalWithPortal>
  );
};

export default VideoPlayerPortal;
